import React, { useState, useEffect } from "react"
import { startOfDay, endOfDay, subDays, startOfMonth, endOfMonth, subMonths, startOfYear, endOfYear } from 'date-fns';
import PopupFilteringCallQueuePost from "./PopupFilteringCallQueuePost.jsx";
import { useTranslation } from "react-i18next";
import PopupFilteringCallQueue from "./PopupFilteringCallQueue";

export default function FilteringCallQueue({ data, people, setFilteredData, reportType, setStatusReport, showPostPopup, setShowPostPopup, showGroupPopup, setShowGroupPopup, setShowEmailPopup, callQueue, user, setFilteredPosts }) {
    const today = endOfDay(new Date());

    const [filters, setFilters] = useState({
        groups: false,
        date: false,
        post: false,
        callType: false,
    });

    const [filterValues, setFilterValues] = useState({
        groups: [],
        date: '',
        post: [],
        callType: '',
    });

    const { t, i18n } = useTranslation();

    useEffect(() => {
        if (reportType) {
            setFilterValues({
                groups: [],
                date: '',
                post: [],
                callType: '',
            });
            setFilters({
                groups: false,
                date: false,
                post: false,
                callType: false,
            });
            setFilteredData(data);

            if (setFilteredPosts) {
                setFilteredPosts({ posts: [], calltype: '' });
            }
        }
    }, [reportType, data, setFilteredData, setFilteredPosts]);

    const handleFilterChange = (filter) => {
        setFilters((prev) => ({ ...prev, [filter]: !prev[filter] }));
    };

    const handleValueChange = (filter, value) => {
        setFilterValues((prev) => ({ ...prev, [filter]: value }));
    };

    const handleGroupChange = (groupement) => {
        setFilterValues((prev) => {
            if (prev.groups.includes(groupement)) {
                return { ...prev, groups: prev.groups.filter(group => group !== groupement) };
            } else {
                return { ...prev, groups: [...prev.groups, groupement] };
            }
        });
    };

    const handlePostChange = (number) => {
        setFilterValues((prev) => {
            if (prev.post.includes(number)) {
                return { ...prev, post: prev.post.filter(post => post !== number) };
            } else {
                return { ...prev, post: [...prev.post, number] };
            }
        });
    };

    const applyFilters = () => {
        let filteredData = data.flat(Infinity);
        const isHolding = user?.holdingId === 33;

        if (filters.groups && filterValues.groups.length > 0) {
            filteredData = filteredData.filter(item => {
                if (isHolding && item.calleridnumber) {
                    return filterValues.groups.includes(item.calleridnumber);
                }
                return filterValues.groups.includes(item.callednumber) ||
                    filterValues.groups.includes(item.callingnumber);
            });
        }

        if (filters.date) {
            filteredData = filteredData.filter(item => {
                const callDate = new Date(item.starttime);
                switch (filterValues.date) {
                    case 'today':
                        return callDate >= startOfDay(today) && callDate <= endOfDay(today);
                    case 'yesterday':
                        return callDate >= startOfDay(subDays(today, 1)) && callDate <= endOfDay(subDays(today, 1));
                    case 'last2days':
                        return callDate >= startOfDay(subDays(today, 2)) && callDate <= endOfDay(today);
                    case 'thisweek':
                        return callDate >= startOfDay(subDays(today, 7)) && callDate <= endOfDay(today);
                    case 'last7days':
                        return callDate >= startOfDay(subDays(today, 7)) && callDate <= endOfDay(today);
                    case 'lastweek':
                        return callDate >= startOfDay(subDays(today, 14)) && callDate <= endOfDay(subDays(today, 7));
                    case 'thismonth':
                        return callDate >= startOfMonth(today) && callDate <= endOfMonth(today);
                    case 'last30days':
                        return callDate >= startOfDay(subDays(today, 30)) && callDate <= endOfDay(today);
                    case 'lastmonth':
                        return callDate >= startOfMonth(subMonths(today, 1)) && callDate <= endOfMonth(subMonths(today, 1));
                    case 'thelast2months':
                        return callDate >= startOfMonth(subMonths(today, 2)) && callDate <= endOfMonth(subMonths(today, 1));
                    case 'lasttrimestre':
                        return callDate >= startOfDay(subDays(today, 90)) && callDate <= endOfDay(today);
                    case 'last60days':
                        return callDate >= startOfDay(subDays(today, 60)) && callDate <= endOfDay(today);
                    case 'last3months':
                        return callDate >= startOfDay(subDays(today, 90)) && callDate <= endOfDay(today);
                    case 'thisyear':
                        return callDate >= startOfYear(today) && callDate <= endOfYear(today);
                    case 'last12months':
                        return callDate >= startOfDay(subDays(today, 365)) && callDate <= endOfDay(today);
                    case 'lastyear':
                        return callDate >= startOfYear(subMonths(today, 12)) && callDate <= endOfYear(subMonths(today, 12));
                    case 'Last2years':
                        return callDate >= startOfYear(subMonths(today, 24)) && callDate <= endOfYear(subMonths(today, 12));
                    default:
                        return true;
                }
            });
        }

        // if (filters.post && filterValues.post.length > 0) {
        //     filteredData = filteredData.filter(item => {
        //         if (isHolding && item.calleridnumber) {
        //             return filterValues.post.includes(item.calleridnumber);
        //         }
        //         return filterValues.post.includes(item.callednumber) || filterValues.post.includes(item.callingnumber);
        //     });
        // }


        if (filters.callType && reportType === 'Analyse par groupement') {
            filteredData = filteredData.filter(item => {
                const isAnswered = item.answerindicator === "Yes" || item.answerindicator === "Yes-PostRedirection";
                const isNotAnswered = item.answerindicator === "No";

                if (filterValues.callType === 'Sortants') return item.direction === "ORIGINATING";
                if (filterValues.callType === 'Entrants') return item.direction === "TERMINATING";
                if (filterValues.callType === 'Répondus') return isAnswered;
                if (filterValues.callType === 'Sans réponse') return isNotAnswered;
                if (filterValues.callType === 'Appels sortants sans réponse') return item.direction === "ORIGINATING" && !isAnswered;
                if (filterValues.callType === 'Appels sortants avec réponse') return item.direction === "ORIGINATING" && isAnswered;
                if (filterValues.callType === "Appels entrants sans réponse") return item.direction === "TERMINATING" && isNotAnswered;
                if (filterValues.callType === "Appels entrants avec réponse") return item.direction === "TERMINATING" && isAnswered;

                return true;
            });
        }

        setFilteredData(filteredData);

        if (setFilteredPosts) {
            setFilteredPosts({
                posts: filters.post ? filterValues.post : [],
                calltype: filters.callType ? filterValues.callType : ''
            });
        }

        setStatusReport("success");
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        applyFilters();
    };


    return (
        <section className="statistics-report-content">
            <div>
                <h1>
                    {t(`${reportType}`) === "Analyse temporelle (HH, JJ...)" ? "Analyse temporelle (heures, jours, mois ou trimestres)" : t(`${reportType}`)}
                </h1>
                <div className="filtering-options-report-content">
                    <h2 className="title-option-report-webex-filter">{t("Options du rapport :")}</h2>
                    <form onSubmit={handleSubmit}>
                        {reportType === 'Analyse par groupement' && (
                            <div className="filter-report-webex">
                                <input
                                    type="checkbox"
                                    checked={filters.groups}
                                    onChange={() => handleFilterChange('groups')}
                                />
                                <span>{t("Type de groupement")} :</span>
                                <button className="button-openselected-post-webex" type="button" onClick={() => filters.groups && setShowGroupPopup(true) + setShowEmailPopup(false) + setShowPostPopup(false)}>...</button>
                                {showGroupPopup && filters.groups && (
                                    <PopupFilteringCallQueue
                                        data={callQueue}
                                        filterValues={filterValues}
                                        handleGroupChange={handleGroupChange}
                                        onSubmit={(selected) => { setFilterValues(p => ({ ...p, groups: selected })); setShowGroupPopup(false); }}
                                        onCancel={() => setShowGroupPopup(false)}
                                        people={people}
                                    />
                                )}
                            </div>
                        )}
                        <div className="filter-report-webex">
                            <input
                                type="checkbox"
                                checked={filters.date}
                                onChange={() => handleFilterChange('date')}
                            />
                            <span>{t("Pour les appels avec date :")}</span>
                            <select
                                value={filterValues.date}
                                onChange={(e) => handleValueChange('date', e.target.value)}
                                disabled={!filters.date}
                            >
                                <option value=""></option>
                                <option value="today">{t("Aujourd'hui")}</option>
                                <option value="yesterday">{t("Hier")}</option>
                                <option value="last2days">{t("2 derniers jours")}</option>
                                <option value="thisweek">{t("Cette semaine")}</option>
                                <option value="last7days">{t("7 derniers jours")}</option>
                                <option value="lastweek">{t("La semaine dernière")}</option>
                                <option value="thismonth">{t("Ce mois-ci")}</option>
                                <option value="last30days">{t("30 derniers jours")}</option>
                                <option value="lastmonth">{t("Le mois dernier")}</option>
                                <option value="thelast2months">{t("Les deux derniers mois")}</option>
                                <option value="lasttrimestre">{t("Dernier trimestre")}</option>
                                <option value="last60days">{t("60 derniers jours")}</option>
                                <option value="last3months">{t("3 derniers mois")}</option>
                                <option value="thisyear">{t("Cette année")}</option>
                                <option value="last12months">{t("12 derniers mois")}</option>
                                <option value="lastyear">{t("L'année dernière")}</option>
                                <option value="Last2years">{t("Deux dernières années")}</option>
                            </select>
                        </div>
                        {reportType !== 'Analyse par groupement' && (
                            <div className="filter-report-webex">
                                <input
                                    type="checkbox"
                                    checked={filters.post}
                                    onChange={() => handleFilterChange('post')}
                                />
                                <span>{t("Pour un groupe restreint de postes :")}</span>
                                <button className="button-openselected-post-webex" type="button" onClick={() => filters.post && setShowPostPopup(true) + setShowEmailPopup(false)}>...</button>
                                {showPostPopup && filters.post && (
                                    <PopupFilteringCallQueuePost
                                        data={data}
                                        filterValues={filterValues}
                                        handlePostChange={handlePostChange}
                                        onSubmit={(selected) => { setFilterValues(p => ({ ...p, post: selected })); setShowPostPopup(false); }}
                                        onCancel={() => setShowPostPopup(false)}
                                        people={people}
                                        user={user}
                                        callQueue={callQueue}
                                    />
                                )}
                            </div>
                        )}
                        <div className="filter-report-webex">
                            <input
                                type="checkbox"
                                checked={filters.callType}
                                onChange={() => handleFilterChange('callType')}
                            />
                            <span>{t("Pour les appels de type :")}</span>
                            <select
                                value={filterValues.callType}
                                onChange={(e) => handleValueChange('callType', e.target.value)}
                                disabled={!filters.callType}
                            >
                                <option value=""></option>
                                <option value="Répondus">{t("Répondus")}</option>
                                <option value="Sans réponse">{t("Sans réponse")}</option>
                            </select>
                        </div>
                        <button className="submit-report-webex" type="submit">{t("Exécuter le rapport")}</button>
                    </form>
                </div>
            </div>
        </section>
    )
}